import React from 'react';
import { LeadForm } from '../../components/LeadForm';
export function KidsMartialArtsHeroForm() {
  return <div className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative" data-id="element-2120">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-2121">
        Find the Right Kids Class
      </div>
      <div className="mt-4" data-id="element-2122">
        <LeadForm buttonText="Start With a Trial Class" defaultProgram="Kids Taekwondo (Ages 6+)" showChildAge={true} data-id="element-2123" />
      </div>
    </div>;
}